import { Campaign } from './Campaign'
import type { CampaignDataAccessObject } from './CampaignDataAccessObject'

export class CampaignEncoder {
  static encode(instance: Campaign): CampaignDataAccessObject {
    return {
      id: instance.id.value,
      discounted: instance.discounted.value,
      original: instance.original.value,
    }
  }

  static decode(campaign: CampaignDataAccessObject): Campaign {
    return new Campaign(campaign.id, campaign.discounted, campaign.original)
  }
}
